import { render, staticRenderFns } from "./LgbtqPicker.vue?vue&type=template&id=4ae67c3a&"
import script from "./LgbtqPicker.vue?vue&type=script&lang=js&"
export * from "./LgbtqPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports